export enum CareProposalChannel {
  CREATE = 'careProposal::create',
  EDIT = 'careProposal::patch',
  DELETE = 'careProposal::delete',
}
